export default __webpack_public_path__ + "static/media/menuCopiarCard.6f3d2021.svg";